__turbopack_context__.v({
  "empty": "ProspectLinkedinFeed-module__iXDE8G__empty",
  "loader": "ProspectLinkedinFeed-module__iXDE8G__loader",
  "note": "ProspectLinkedinFeed-module__iXDE8G__note",
  "pager": "ProspectLinkedinFeed-module__iXDE8G__pager",
  "panel": "ProspectLinkedinFeed-module__iXDE8G__panel",
  "period": "ProspectLinkedinFeed-module__iXDE8G__period",
  "periodActive": "ProspectLinkedinFeed-module__iXDE8G__periodActive",
  "periodList": "ProspectLinkedinFeed-module__iXDE8G__periodList",
  "text": "ProspectLinkedinFeed-module__iXDE8G__text",
  "title": "ProspectLinkedinFeed-module__iXDE8G__title",
  "trigger": "ProspectLinkedinFeed-module__iXDE8G__trigger",
  "triggerActive": "ProspectLinkedinFeed-module__iXDE8G__triggerActive",
});
